import React from "react";
import AddProduct from "../../components/Products/AddProduct/AddProduct";

export default function ProductForm() {
  return <AddProduct />;
}
